import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button, Flex, Icon, Icons, Text } from "src/components";
import { Color } from "src/theme";
import type { SortableColumn, TableSort } from "../sort";

export type UserTableHeaderProps = {
    column: SortableColumn;
    title: string;
    setSort: (column: SortableColumn) => void;
    sort: TableSort;
};

export const UserTableHeader: FC<UserTableHeaderProps> = ({ title, setSort, sort, column }) => {
    const { t } = useTranslation();
    const isActive = sort.column === column;

    return (
        <Flex alignItems="center" gap="0.5rem">
            <Button onClick={() => setSort(column)}>
                <Text color={Color.white}>{title}</Text>
            </Button>
            {isActive && <Icon icon={sort.direction === "ASC" ? Icons.ArrowUp : Icons.ArrowDown} height={16} width={20} alt={t("sort")} />}
        </Flex>
    );
};
